import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Badge } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import FilterCreator from './FilterCreator/FilterCreator';
import { useTranslate } from 'react-polyglot';

import './FilterSelector.scss';
import FilterEditor from './FilterEditor/FilterEditor';

function FilterSelector(props) {
	const auth = useAuth();
	const axiosHandler = useAxios();
	const axios = axiosHandler.axios;
    const t = useTranslate();
    const history = useHistory();
    
	const [ filters, setFilters ] = useState<Array<any>>([]);
	const [ selected, setSelected ] = useState("");

	const [ showCreateNew, setShowCreateNew ] = useState(false);
	const [ showEdit, setShowEdit ] = useState(false);

	const [ editFilter, setEditFilter ] = useState();

	async function fetchData() {
		axios.single({
            method: 'get',
            url: props.filtersUrl + props.filterType,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'] }
        })
        .then((res) => {
            setFilters(res.data);

            const params = new URLSearchParams(window.location.search);
            if (params.has("filter")) {
                let filter = params.get("filter");
                if (res.data.find(i => i["_id"] == filter) != undefined) {
                    setSelected(filter as string);
                    if (props.onChange != undefined) { props.onChange(res.data.find(i => i["_id"] == filter)); }
                }
            }
            if (props.onLoaded != undefined) { props.onLoaded(res.data); }
        });
    }
    
    function deletefilter(id) {
        axios.delete("/api/filters/" + id, {
            id: id,
        }, {
            headers: {'x-access-token': auth.user["token"]}
        }).then(res => {
            fetchData();
        });
    }

	useEffect(() => {
        fetchData();
    }, []);

	return (
		<div className="filterselector">
            <Badge pill className={selected == "" ? "selected" : ""} onClick={(evt) => {
                if (props.onChange != undefined) { props.onChange({filters: []}); }
                setSelected("");
                history.push({
                    pathname: '',
                    search: ''
                });
            }}>
                {t("filters.filterselector.showallitems")}
            </Badge>
            {filters.map((filter, key) => 
                <Badge key={key} className={filter._id == selected ? "selected" : ""} pill onClick={(evt) => {
                    if (props.onChange != undefined) { props.onChange(filter); }
                    setSelected(filter._id);
                    history.push({
                        pathname: '',
                        search: '?filter=' + filter._id
                    });
                }}>
                    {filter.name} 
                    { props.onEditClick != undefined ?
                        <i className="dripicons-brush" style={{marginLeft: "14px"}} onClick={(evt) => {
                            props.onEditClick();
                            evt.stopPropagation();
                            evt.preventDefault();

                            setShowEdit(true);
                            setEditFilter(filter);
                        }} />
                    : null}
                    { props.onDeleteClick != undefined ?
                        <i className="dripicons-trash" style={{marginLeft: "6px"}} onClick={(evt) => {
                            props.onDeleteClick();
                            evt.stopPropagation();
                            evt.preventDefault();

                            let confirmed = window.confirm(t("filters.filterselector.confirmdelete"));
                            if (confirmed) {
                                deletefilter(filter["_id"]);
                            }
                        }} />
                    : null}
                </Badge>
            )}
            {props.onAddClick != undefined ?
                <Badge pill style={{ borderStyle: "dashed" }} onClick={(evt) => {
                    setShowCreateNew(true);
                }}>
                    + {props.addFilterText != undefined ? props.addFilterText : ""}
                </Badge>
            : null}
            <FilterCreator
                filterType={props.filterType}
                show={showCreateNew}
                fields={props.fields != undefined ? props.fields : undefined}
                onClose={() => setShowCreateNew(false)}
                onHide={() => setShowCreateNew(false)}
                onCreated={() => fetchData()}
            ></FilterCreator>
            <FilterEditor
                filterType={props.filterType}
                filter={editFilter}
                show={showEdit}
                fields={props.fields != undefined ? props.fields : undefined}
                onClose={() => setShowEdit(false)}
                onHide={() => setShowEdit(false)}
                onEdited={() => fetchData()}
            ></FilterEditor>
		</div>
	);
}

export default FilterSelector;
